/* Pixel Company theme JS — no dependencies */
(function () {
  'use strict';
  var T = window.PixelTheme || { routes: { cartAdd: '/cart/add', cart: '/cart' }, moneyFormat: '${{amount}}' };

  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    var withDelims = function (n, d, t, s) {
      var p = n.toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? s + p[1] : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withDelims(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelims(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(v, 0, '.', ',');
      return withDelims(v, 2, ',', '.');
    });
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.setAttribute('data-count', n);
    });
  }
  var toastTimer;
  function toast(item) {
    var t = document.getElementById('CartToast'); if (!t) return;
    var img = document.getElementById('CartToastImg');
    if (item.image) { img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; img.hidden = false; } else { img.hidden = true; }
    document.getElementById('CartToastTitle').textContent = item.product_title + (item.variant_title ? ' — ' + item.variant_title : '');
    t.classList.add('on'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }
  function addToCart(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        toast(res.items[0]);
        return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function (e) { alert((e && (e.description || e.message)) || 'Could not add to cart.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) { e.preventDefault(); addToCart(q.getAttribute('data-quick-add'), 1, q); }
  });

  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qty = form.querySelector('[name="quantity"]');
      addToCart(id, qty ? qty.value : 1, form.querySelector('[type="submit"]'));
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var input = b.parentNode.querySelector('input'); if (!input) return;
    var v = Math.max(Number(input.min || 1), (Number(input.value) || 1) + Number(b.getAttribute('data-qty')));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product page ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('script[data-product-json]'); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-ajax-cart]');
    var idInput = form && form.querySelector('[name="id"]');
    var mainImg = root.querySelector('.js-main-img');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function showMedia(src, mediaId) {
      if (!mainImg || !src) return;
      mainImg.src = src; mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-media-id') === String(mediaId))); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-src'), t.getAttribute('data-media-id')); });
    });

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function update() {
      var opts = selected();
      root.querySelectorAll('[data-option]').forEach(function (fs, i) {
        var v = fs.querySelector('[data-option-value]'); if (v) v.textContent = opts[i];
        // mark unavailable values given other selections
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var match = product.variants.find(function (vv) { return vv.options.every(function (o, k) { return o === test[k]; }); });
          var lab = inp.nextElementSibling; if (lab) lab.classList.toggle('na', !match || !match.available);
        });
      });
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      var btn = root.querySelector('[data-add-btn]');
      var btnText = root.querySelector('[data-add-text]');
      if (!variant) { if (btn) btn.disabled = true; if (btnText) btnText.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(variant.price); });
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        var on = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.textContent = on ? money(variant.compare_at_price) : ''; el.hidden = !on;
      });
      root.querySelectorAll('[data-save]').forEach(function (el) {
        var on = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.hidden = !on; if (on) el.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
      });
      if (btn) btn.disabled = !variant.available;
      if (btnText) btnText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      document.querySelectorAll('[data-sticky-add]').forEach(function (b) { b.disabled = !variant.available; });
      if (variant.featured_media) showMedia(variant.featured_media.preview_image.src + '&width=1200', variant.featured_media.id);
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(); });
    update();

    // sticky mobile bar
    var sticky = root.querySelector('[data-sticky-buy]');
    var addBtn = root.querySelector('[data-add-btn]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(addBtn);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });

  /* ---------- featured collection tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        wrap.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      });
    });
  });

  /* ---------- countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    var cells = el.querySelectorAll('b');
    function tick() {
      var d = Math.max(0, end - Date.now());
      var v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
      cells.forEach(function (c, i) { c.textContent = String(v[i]).padStart(2, '0'); });
      if (d === 0 && el.hasAttribute('data-hide-on-end')) el.closest('section').hidden = true;
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- close header popovers on outside click ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-popover][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- sort select ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
